import { className } from '../../../utils/GlobalCssProxy';
import PropTypes from 'prop-types';

const GrayText = ({ label, isString, value, grayTextDisclosure, textClass }) => {
  GrayText.propTypes = {
    label: PropTypes.string,
    isString: PropTypes.bool,
    value: PropTypes.any,
    grayTextDisclosure: PropTypes.string,
    textClass: PropTypes.string
  };
  return (
    <div
      {...className(
        `${textClass || 'text-right'}`,
        'font-weight-normal',
        'font-size-11',
        'text-muted'
      )}
    >
      {label}:
      {isString ?
        <span> {value}</span>
        :
        <time> {value}</time>
      }
      {grayTextDisclosure && <p>{grayTextDisclosure}</p>}
    </div>
  );
};

export default GrayText;
